import React from "react";
import { Card, CardBody } from "reactstrap";

import EmbedShell from "./EmbedShell";
import ClassRoomTable from "../ClassRoom/ClassRoomTable";

/**
 * ELENCO CLASSI in modalita' embed (dentro l'iframe di ATOM).
 *
 * Stessa tabella della pagina /classroom, dentro il guscio embed: niente header ne'
 * sidebar, navigazione confinata, sessione dal gettone. La prop `embed` spegne le
 * uscite della tabella (bottone pagamenti in attesa, link al dettaglio classe).
 */
const EmbedClassi = () => {
    document.title = "Classi | CLTV";
    return (
        <EmbedShell titolo="Elenco Classi">
            <Card><CardBody>
                <ClassRoomTable embed={true} />
            </CardBody></Card>
        </EmbedShell>
    );
};

export default EmbedClassi;
